import StreetSurface from "../../components/dashboard/street_surface/StreetSurface";

export default function StreetSurfacePage() {
  
  return (
    <main id="page-content" className="flex max-w-full flex-auto flex-col">
      <StreetSurface />
    </main>
  )
}